import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { endOfMinute } from "date-fns";
import type { GigBoardArgs } from "domains/schedule/containers/GigBoard/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";
import { queries as gigViewLayoutQueries } from "../GigViewLayout/queries";

type QueriesInput = {
  search: MarketplaceSearch;
  location: ForManagerLocationDetail | undefined;
  now: Date;
  isAdmin: boolean;
};

export const payGigArgs = (now: Date): GigBoardArgs => ({
  viewType: "HOME",
  end_time__lte: endOfMinute(now),
  ordering: "end_time, id",
  query: "incomplete",
});

export const queries = ({ search, location, now, isAdmin }: QueriesInput): Array<WarmableQuery> =>
  gigViewLayoutQueries({ search, location, now, isAdmin, defaultView: "list", queryArgs: payGigArgs });
